import styled from 'styled-components';
import Input from 'components/ui/Input';
import Select from 'components/ui/Select';
import Label from 'components/ui/Label';

import { colours, fonts } from 'themes/default';
const { fontStyleRegular } = fonts;

export const StyledContainer = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  margin: 16px;
`;

export const StyledTitle = styled.h1`
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 16px;
  width: 100%;
  max-width: 70%;
`;

export const StyledForm = styled.form`
  display: flex;
  width: 100%;
  max-width: 70%;
  flex-flow: column;
  background-color: ${colours.Shades.TintBlue10};
  padding: 10px;
`;

export const MandatoryFieldLabel = styled(Label)`
  &::after {
    content: ' *';
    color: red;
  }
`;

export const Field = styled.div`
  margin: 0.4em 0;
  display: inline-block;
  width: 100%;
`;

export const ErrorField = styled.div`
  color: red;
  margin-top: 4px;
  margin-bottom: 4px;
`;

export const StyledRow = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 16px;
`;

export const StyledInput = styled(Input)`
  line-height: 1;
  box-sizing: border-box;
`;

export const StyledSelect = styled(Select)`
  ${fontStyleRegular}
  line-height: 1;
  font-size: 16px;
  border: 0.05em solid ${colours.Shades.TintBlue20};
  padding: 0.3em;
  border-radius: 0.35em;
  background-color: ${colours.Greyscale.White};
  width: 100%;
  height: 34px;
  box-sizing: border-box;
`;

export const StyledActionButtonContainers = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 16px;
  justify-content: flex-start;
`;

export const StyledMetadataContainer = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  width: 100%;
  margin-top: 16px;
  margin-bottom: 16px;
  gap: 8px;
`;

export const StyledMetadataRow = styled.div`
  display: contents;
`;

export const StyledMetadataLabel = styled(Label)`
  font-weight: 700;
  grid-column: 1;
`;

export const StyledMetadataValue = styled.div`
  grid-column: 2;
`;

export const StyledTravelDate = styled.div`
  ${fontStyleRegular};
  margin-top: 8px;
  margin-bottom: 4px;
`;

export const StyledLabel = styled.label`
  cursor: pointer;
`;

export const StyledLink = styled.button`
  cursor: pointer;
  text-decoration: underline;
  box-shadow: none;
  background: none;
  border: none;
  color: ${colours.Core.CoreNavy};
`;
